// src/services/newsletterSubscriberServices.js

import axios from "axios";

const baseUrl = `${process.env.REACT_APP_API_URL}/api/newsletter-subscribers`;

export async function subscribeNewsletter(email) {
  const response = await axios.post(baseUrl, { email });
  return response.data;
}

export async function getNewsletterSubscribers(params = {}, token) {
  const response = await axios.get(baseUrl, {
    params,
    headers: token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : undefined,
  });

  return response.data;
}

export async function toggleNewsletterSubscriberImported(id, value, token) {
  const response = await axios.patch(
    `${baseUrl}/${id}/imported`,
    {
      is_imported_to_contacts: value,
    },
    {
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    },
  );

  return response.data;
}

export async function deleteNewsletterSubscriber(id, token) {
  const response = await axios.delete(`${baseUrl}/${id}`, {
    headers: token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : undefined,
  });

  return response.data;
}
